<template>
    <div class="stage">
        <div class="questions-wrapper">
            <div class="questions-block">
                <div class="question-block">
                    <div class="question" :class="isActiveIll ? 'isActive' : ''">
                        Відмітьте пункти, якщо вони стосуються історії хвороби
                    </div>
                    <div class="checkpoints">
                        <label class="checkpoint" :class="illHistoryBool.isExtraExercise ? 'active' : ''">Присутні екстранодальні ураження
                            <input type="checkbox" v-model="illHistoryBool.isExtraExercise" :checked="illHistoryBool.isExtraExercise">
                            <span class="checkmark"></span>
                        </label>

                        <label class="checkpoint" :class="illHistoryBool.isBasePetKt ? 'active' : ''">Проводилась базова ПЕТ-КТ
                            <input type="checkbox" v-model="illHistoryBool.isBasePetKt" :checked="illHistoryBool.isBasePetKt">
                            <span class="checkmark"></span>
                        </label>

                        <label class="checkpoint" :class="illHistoryBool.isBSymptoms ? 'active' : ''">Присутні В-симптоми
                            <input type="checkbox" v-model="illHistoryBool.isBSymptoms" :checked="illHistoryBool.isBSymptoms">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>

                <error-block />
            </div>
        </div>
    </div>
</template>

<script>
import ErrorBlock from '../../../../../components/Doctor/ErrorBlock';
import { mapMutations, mapGetters } from 'vuex';

export default {
    components : {
        'error-block' : ErrorBlock
    },
    data : () => ({
        illHistory : {
            isExtraExercise : '',
            isBasePetKt : '',
            isBSymptoms : ''
        },
        illHistoryBool : {
            isExtraExercise : '',
            isBasePetKt : '',
            isBSymptoms : ''
        }   
    }),
    computed : {
        ...mapGetters([
            'getIllHistoryPoints',
        ]),
        isActiveIll: function(){
            if(this.illHistoryBool.isExtraExercise)
                return true;
            else if(this.illHistoryBool.isBasePetKt)
                return true;
            else if(this.illHistoryBool.isBSymptoms)
                return true;
            else
                return false;
        }
    },
    methods : {
        ...mapMutations([
            'setIllHistory',
        ])
    },
    created(){
        this.illHistory = this.getIllHistoryPoints;

        this.illHistoryBool.isExtraExercise = this.illHistory.isExtraExercise === 'Присутні екстранодальні ураження';
        this.illHistoryBool.isBasePetKt = this.illHistory.isBasePetKt === 'Результат базової ПЕТ-КТ';
        this.illHistoryBool.isBSymptoms = this.illHistory.isBSymptoms === 'Присутні В-симптоми';
    },
    watch : {
        illHistory : {
            handler(value){
                this.setIllHistory(value);
            },
            deep : true
        },
        illHistoryBool : {
            handler(value){
                if(value.isExtraExercise)
                    this.illHistory.isExtraExercise = 'Присутні екстранодальні ураження';
                else
                    this.illHistory.isExtraExercise = '';

                if(value.isBasePetKt)
                    this.illHistory.isBasePetKt = 'Результат базової ПЕТ-КТ';
                else
                    this.illHistory.isBasePetKt = '';

                if(value.isBSymptoms)
                    this.illHistory.isBSymptoms = 'Присутні В-симптоми';
                else
                    this.illHistory.isBSymptoms = '';
            },
            deep : true
        }
    }
}
</script>

<style lang="scss" scoped>
.stage{
    .questions-wrapper{
        width: 438px;
        height: 351px;

        .questions-block{
            padding: 32px 40px 44px 40px;

            .question-block{
                .question{
                    font-size: 26px;
                    padding-left: 32px;

                    &.isActive{
                        padding-left: 0;
                    }
                }

                .checkpoints{
                    position: relative;

                    .checkpoint{
                        text-align: left;

                        padding: 13px 19px;
                        margin-bottom: 10px;

                        background: #FFFFFF;
                        box-shadow: 4px 4px 20px rgba(37, 93, 111, 0.1);
                        border-radius: 50px;

                        display: flex;
                        align-items: center;

                        margin-left: 32px;

                        &.active{
                            margin-left: 0;
                            width: calc(100% - 92px);
                            color: #00607E;

                            border: 1px solid rgba(0, 96, 126, 0.75);
                        }
                    }

                    /* The container */
                    .checkpoint {
                        display: block;
                        position: relative;
                        cursor: pointer;
                        font-size: 22px;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;

                        color: #757575;
                        font-style: normal;
                        font-weight: 750;
                        font-size: 14px;
                        line-height: 24px;

                        padding-left: 40px;
                    }

                    /* Hide the browser's default checkbox */
                    .checkpoint input {
                        position: absolute;
                        opacity: 0;
                        cursor: pointer;
                        height: 0;
                        width: 0;
                    }

                    input:focus {
                        outline: none;
                        border: none;
                        background: none;
                    }

                    /* Create a custom checkbox */
                    .checkmark {
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        left: 14px;

                        margin-top: auto;
                        margin-bottom: auto;

                        height: 18px;
                        width: 18px;

                        background-color: none;
                        opacity: 0.1;
                        border: 1px solid #000000;
                        box-sizing: border-box;
                        border-radius: 3px;
                    }

                    /* On mouse-over, add a grey background color */
                    .checkpoint:hover input ~ .checkmark {
                        background-color: none;
                        opacity: 0.1;
                        border: 1px solid #000000;
                        box-sizing: border-box;
                        border-radius: 3px;
                    }

                    /* When the checkbox is checked, add a blue background */
                    .checkpoint input:checked ~ .checkmark {
                        opacity: 1;
                        border: none;
                        border-radius: 3px;
                        background-color: rgba(0, 96, 126, 0.75);
                    }

                    /* Create the checkmark/indicator (hidden when not checked) */
                    .checkmark:after {
                        content: "";
                        position: absolute;
                        display: none;
                    }

                    /* Show the checkmark when checked */
                    .checkpoint input:checked ~ .checkmark:after {
                        display: block;
                    }

                    /* Style the checkmark/indicator */
                    .checkpoint .checkmark:after {
                        left: 0;
                        top: 0;
                        right: 0;
                        bottom: 3px;

                        margin: auto;

                        width: 4px;
                        height: 8px;
                        border: solid white;
                        border-width: 0 2px 2px 0;
                        -webkit-transform: rotate(45deg);
                        -ms-transform: rotate(45deg);
                        transform: rotate(45deg);
                    }
                }
            }           
        }        
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .stage{
        .questions-wrapper{
            width: 35vw;
            height: auto;

            .questions-block{
                padding: 3vw 3.333vw;

                .question-block{
                    .question{
                        font-size: 1.667vw;
                        padding-left: 2vw;
                    }

                    .checkpoints{
                        .checkpoint{
                            padding: 1.042vw 2.083vw;
                            margin-bottom: 1.042vw;

                            margin-left: 2vw;

                            &.active{
                                margin-left: 0;
                                width: calc(100% - 8vw);
                            }
                        }

                        /* The container */
                        .checkpoint {
                            font-size: 1.042vw;
                            line-height: 1.2vw;

                            padding-left: 3vw;
                        }

                        /* Create a custom checkbox */
                        .checkmark {
                            left: 1.042vw;

                            height: 1.198vw;
                            width: 1.198vw;
                        }


                        /* Style the checkmark/indicator */
                        .checkpoint .checkmark:after {
                            bottom: 0.208vw;

                            width: 0.365vw;
                            height: 0.625vw;

                            border-width: 0 0.156vw 0.156vw 0;
                        }
                    }
                }

            }
        }
    }
}

@media (max-width: 599px){
    .stage{
        .questions-wrapper{
            width: 100%;
            height: auto;

            .questions-block{
                padding: 5.556vw 5.278vw 6.667vw 5.556vw;

                .question-block{
                    .question{
                        font-size: 5.556vw;
                        line-height: 6.5vw;

                        padding-left: 8.889vw;
                    }

                    .checkpoints{
                        .checkpoint {
                            font-size: 3.5vw;
                            line-height: 4.5vw;

                            padding-left: 11.111vw;
                        }
                    }
                }
            }
        }
    }
}
</style>